(() => {
  const sectionSelector = '[data-emy-services-expand]';
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const styleId = 'emy-services-runtime-fixes';
  let cursorHint;

  const injectStyles = () => {
    let style = document.getElementById(styleId);

    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }

    style.textContent = `
      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card {
        cursor: pointer !important;
      }

      /* Remove every dark overlay and gradient from the service cards. */
      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card::after {
        background: none !important;
        background-image: none !important;
        opacity: 0 !important;
      }

      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card .text-block {
        z-index: 30 !important;
        isolation: isolate !important;
        mix-blend-mode: normal !important;
        background: none !important;
        background-color: transparent !important;
        background-image: none !important;
      }

      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card .text-block::before {
        content: none !important;
        display: none !important;
        background: none !important;
        background-image: none !important;
      }

      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card .text-block,
      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card .text-block * {
        color: #ffffff !important;
        -webkit-text-fill-color: #ffffff !important;
        visibility: visible !important;
        filter: none !important;
        mix-blend-mode: normal !important;
      }

      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card.is-active .text-block {
        opacity: 1 !important;
        visibility: visible !important;
        transform: translateZ(0) !important;
        pointer-events: auto !important;
      }

      /* Keep the title clickable, but restore its original text-only appearance. */
      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card .text-block a {
        display: inline-flex !important;
        align-items: center !important;
        gap: 10px !important;
        width: auto !important;
        min-width: 0 !important;
        max-width: 100% !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline-offset: 4px;
        background: none !important;
        background-color: transparent !important;
        background-image: none !important;
        box-shadow: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
        text-decoration: none !important;
        appearance: none !important;
        -webkit-appearance: none !important;
      }

      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card .text-block a::before {
        content: none !important;
        display: none !important;
        background: none !important;
        box-shadow: none !important;
      }

      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card .text-block a::after {
        position: static !important;
        inset: auto !important;
        width: auto !important;
        height: auto !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        box-shadow: none !important;
      }

      .emy-services-expand .carousel-content slideshow-slides > .card.is-service-card .text-block :is(h1, h2, h3, h4, h5, h6, p, span, strong) {
        margin: 0 !important;
        padding: 0 !important;
        background: none !important;
        border: 0 !important;
        box-shadow: none !important;
        color: #ffffff !important;
        -webkit-text-fill-color: #ffffff !important;
        text-shadow:
          0 2px 7px rgba(0, 0, 0, 0.92),
          0 8px 22px rgba(0, 0, 0, 0.62) !important;
      }

      .emy-services-cursor-hint {
        position: fixed;
        z-index: 2147483647;
        top: 0;
        left: 0;
        transform: translate3d(-999px, -999px, 0);
        pointer-events: none;
        opacity: 0;
        padding: 9px 12px;
        border: 1px solid rgba(10, 20, 35, 0.1);
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.97);
        color: #0b1220;
        -webkit-text-fill-color: #0b1220;
        font: 700 12px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing: 0.01em;
        white-space: nowrap;
        box-shadow: 0 10px 30px rgba(2, 8, 20, 0.24);
        transition: opacity 0.15s ease;
        will-change: transform;
      }

      .emy-services-cursor-hint.is-visible {
        opacity: 1;
      }

      @media (hover: none), (max-width: 989px) {
        .emy-services-cursor-hint {
          display: none !important;
        }
      }
    `;
  };

  const forceImportant = (element, property, value) => {
    element?.style.setProperty(property, value, 'important');
  };

  const forceTextContrast = (card) => {
    const textBlock = card.querySelector('.text-block');
    if (!textBlock) return;

    forceImportant(textBlock, 'z-index', '30');
    forceImportant(textBlock, 'visibility', 'visible');
    forceImportant(textBlock, 'filter', 'none');
    forceImportant(textBlock, 'mix-blend-mode', 'normal');
    forceImportant(textBlock, 'background', 'none');
    forceImportant(textBlock, 'background-color', 'transparent');
    forceImportant(textBlock, 'background-image', 'none');

    [textBlock, ...textBlock.querySelectorAll('*')].forEach((element) => {
      forceImportant(element, 'color', '#ffffff');
      forceImportant(element, '-webkit-text-fill-color', '#ffffff');
      forceImportant(element, 'visibility', 'visible');
      forceImportant(element, 'filter', 'none');
      forceImportant(element, 'mix-blend-mode', 'normal');

      if (element !== textBlock) {
        forceImportant(element, 'opacity', '1');
      }
    });
  };

  const getCursorHint = () => {
    if (!cursorHint || !cursorHint.isConnected) {
      cursorHint = document.querySelector('.emy-services-cursor-hint');

      if (!cursorHint) {
        cursorHint = document.createElement('div');
        cursorHint.className = 'emy-services-cursor-hint';
        cursorHint.textContent = 'Ver más';
        cursorHint.setAttribute('aria-hidden', 'true');
        document.body.appendChild(cursorHint);
      }
    }

    return cursorHint;
  };

  const moveHint = (event) => {
    if (!desktopHover.matches) return;

    const hint = getCursorHint();
    hint.style.transform = `translate3d(${event.clientX + 16}px, ${event.clientY + 16}px, 0)`;
  };

  const showHint = (event) => {
    if (!desktopHover.matches) return;

    const hint = getCursorHint();
    moveHint(event);
    hint.classList.add('is-visible');
  };

  const hideHint = () => {
    cursorHint?.classList.remove('is-visible');
  };

  const initialize = (scope = document) => {
    injectStyles();

    const sections = [];

    if (scope.matches?.(sectionSelector)) sections.push(scope);
    scope.querySelectorAll?.(sectionSelector).forEach((section) => sections.push(section));

    sections.forEach((section) => {
      const track = section.querySelector('.carousel-content slideshow-slides');
      if (!track) return;

      const allCards = Array.from(track.children).filter((element) =>
        element.classList.contains('card')
      );

      const serviceCards = allCards.filter((card) => card.querySelector('.image-block'));
      const introCards = allCards.filter((card) => !card.querySelector('.image-block'));

      if (!serviceCards.length) return;

      introCards.forEach((card) => card.classList.add('is-intro-card'));

      const activate = (activeCard) => {
        serviceCards.forEach((card) => {
          const isActive = card === activeCard;
          const textBlock = card.querySelector('.text-block');

          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-expanded', String(isActive));
          forceTextContrast(card);

          if (textBlock && isActive) {
            forceImportant(textBlock, 'opacity', '1');
            forceImportant(textBlock, 'transform', 'translateZ(0)');
            forceImportant(textBlock, 'pointer-events', 'auto');
          } else if (textBlock) {
            textBlock.style.removeProperty('opacity');
            textBlock.style.removeProperty('transform');
            textBlock.style.removeProperty('pointer-events');
          }
        });
      };

      serviceCards.forEach((card) => {
        card.classList.add('is-service-card');
        card.removeAttribute('title');
        forceImportant(card, 'cursor', 'pointer');
        forceTextContrast(card);

        const primaryLink = card.querySelector('.text-block a[href], a[href]');
        const rawLabel = primaryLink?.textContent || card.querySelector('.text-block')?.textContent || '';
        const cleanLabel = rawLabel.replace('↗', '').trim();

        if (primaryLink) {
          card.setAttribute('role', 'link');
          card.setAttribute('tabindex', '0');
          card.setAttribute('aria-label', cleanLabel ? `Ver más: ${cleanLabel}` : 'Ver más');
        }

        if (card.dataset.emyInteractionReady === 'true') return;
        card.dataset.emyInteractionReady = 'true';

        card.addEventListener('pointerenter', (event) => {
          if (desktopHover.matches) activate(card);
          showHint(event);
        });

        card.addEventListener('pointermove', moveHint);
        card.addEventListener('pointerleave', hideHint);
        card.addEventListener('pointerdown', hideHint);
        card.addEventListener('focusin', () => activate(card));

        if (primaryLink) {
          card.addEventListener('click', (event) => {
            const clickedControl = event.target.closest(
              'a, button, input, select, textarea, label, [role="button"]'
            );

            if (clickedControl || event.defaultPrevented || event.button !== 0) return;
            primaryLink.click();
          });

          card.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            hideHint();
            primaryLink.click();
          });
        }
      });

      const currentActive = serviceCards.find((card) => card.classList.contains('is-active'));
      activate(currentActive || serviceCards[0]);
      section.dataset.emyExpandReady = 'true';
      section.classList.add('is-ready');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('blur', hideHint);
})();
